// docs: https://github.com/altostra/type-validations#readme
import { objectOf /*, maybe */ } from "@altostra/type-validations";

export const isAppsCatalogsCatalogIdSubscriptionsDeleteAllResult = objectOf({});
